var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"size":"small"}},[_c('div',{staticClass:"title-container"},[_c('span',[_vm._v("流水线成功率")])]),_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }